<template>
  <div :class="spinnerContainerClass">
    <div
      class="spinner-border"
      :class="spinnerClassList"
      role="status"
    >
      <span class="sr-only">Loading...</span>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    spinnerClassList: {
      type: String,
      default: 'text-primary'
    },
    spinnerContainerClass: {
      type: String,
      default: 'py-4'
    }
  }

}
</script>
